import React, { useState, useEffect } from 'react';
import './TeamActivitiesWidget.css';

function TeamActivitiesWidget({ onViewAll }) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      setLoading(true);
      
      // Fetch last 24h activities for widget (simplified)
      const response = await fetch('/backend/api/dashboard/team-activities.php?filter=24h', {
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.success) {
        // Show only last 10 activities in widget
        setActivities((data.activities || []).slice(0, 10));
      }
    } catch (error) {
      console.error('Error fetching activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  const getActivityIcon = (activity) => {
    // Use provided activity icons
    return '/assets/contacts/activities/new.svg';
  };

  if (loading) {
    return (
      <div className="team-activities-widget">
        <div className="widget-header">
          <h3>Team Activities</h3>
        </div>
        <div className="widget-loading">Loading...</div>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="team-activities-widget">
        <div className="widget-header">
          <h3>Team Activities</h3>
          <button className="btn-view-all" onClick={onViewAll}>View All</button>
        </div>
        <div className="widget-empty">
          <p>No recent activities</p>
          <p className="empty-subtitle">Team activity will appear here</p>
        </div>
      </div>
    );
  }

  return (
    <div className="team-activities-widget">
      <div className="widget-header">
        <h3>Team Activities</h3>
        <button className="btn-view-all" onClick={onViewAll}>View All</button>
      </div>
      
      <div className="activities-list">
        {activities.map((activity, index) => (
          <div key={index} className="activity-row">
            <div className="activity-content">
              <span className="activity-user">{activity.user_name}</span>
              <span className="activity-separator">•</span>
              <span className="activity-action" title={`${activity.action} ${activity.target_name}`}>
                {activity.action} {activity.target_name}
              </span>
            </div>
            <span className="activity-time">{formatTimeAgo(activity.timestamp)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TeamActivitiesWidget;
